module.exports = __webpack_public_path__ + "static/media/warning-icon.dcafdeac.png";